'use-client';
import * as React from 'react';
import type {
  IContainerProps,
  IContainerImperativeActions,
} from '../../../Container.types';
import { BubbleSkinContainer } from '../../shared/BubbleSkinContainer';
import styles from './LeftTriangleArea.scss';

const LeftTriangleArea: React.ForwardRefRenderFunction<
  IContainerImperativeActions,
  IContainerProps
> = (props, ref) => {
  return <BubbleSkinContainer ref={ref} {...props} classes={styles} />;
};

export default React.forwardRef(LeftTriangleArea);
